import { render, staticRenderFns } from "./AddRoom.vue?vue&type=template&id=6a3a31c7"
import script from "./AddRoom.vue?vue&type=script&lang=js"
export * from "./AddRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports